import { faImage } from '@fortawesome/pro-solid-svg-icons';
import styled from 'styled-components';

import { IconButton } from '@sorare/core/src/atoms/buttons/IconButton';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

const Root = styled.div`
  max-width: var(--100vw);
  height: 150px;
  position: relative;
  background-color: var(--c-nd-200);

  &:after {
    content: '';
    position: absolute;
    inset: 0;
    background-color: rgba(var(--c-rgb-black), 0.5);
    z-index: 0;
  }

  img {
    width: 100%;
    height: 150px;
    object-fit: cover;
    object-position: center;
  }
  button {
    position: absolute;
    top: var(--quadruple-unit);
    left: calc(50% - 20px);
    z-index: 1;
  }

  @media ${laptopAndAbove} {
    min-width: 600px;
  }
`;

type Props = {
  pictureUrl?: string | null;
  alt: string;
  onClick: () => void;
};

export const Banner = ({ pictureUrl, alt, onClick }: Props) => {
  return (
    <Root>
      {!!pictureUrl && <img src={pictureUrl} alt={alt} />}
      <IconButton
        size="medium"
        color="transparent"
        icon={faImage}
        onClick={onClick}
      />
    </Root>
  );
};
